//import jwtDecode from "jwt-decode";

// const initialState = {
//     best_selling_products: [],
//     menu: [],
//     new_products: [],
//     sections: [],
//     special_offer_products: [],
//     sliders: []
// }
export const ui = (state = {}, action) => {
    switch (action.type) {
        case "UI": {
            return {
                category_parent: action.payload.category_parent,
                best_selling_products: action.payload.best_selling_products,
                anime_figures: action.payload.anime_figures ,
                non_anime_figures:action.payload.non_anime_figures,
                collection_accessories:action.payload.collection_accessories,
                contact_us: action.payload.contact_us,
                menu: action.payload.menu,
                new_products: action.payload.new_products,
                sections: action.payload.sections,
                special_offer_products: action.payload.special_offer_products,
                daily_products: action.payload.daily_products,
                sliders: action.payload.sliders,
                story: action.payload.story,
                articles: action.payload.articles,
                gallery: action.payload.gallery,
            }
        }
        default: {
            return state
        }
    }
}
